import { ActionCreator, createReducer, on, ReducerTypes } from '@ngrx/store';
import * as actions from './servicing-seatmap-backup.actions';
import { ServicingSeatmapBackupState } from './servicing-seatmap-backup.state';

/**
 * servicingSeatmapBackup initial state
 */
export const servicingSeatmapBackupInitialState: ServicingSeatmapBackupState = {
  model: null,
};

/**
 * List of basic actions for ServicingSeatmapBackup Store
 */
export const servicingSeatmapBackupReducerFeatures: ReducerTypes<ServicingSeatmapBackupState, ActionCreator[]>[] = [
  on(actions.setServicingSeatmapBackup, (_state, payload) => ({ ...payload })),

  on(actions.updateServicingSeatmapBackup, (state, payload) => ({ ...state, ...payload })),

  on(actions.resetServicingSeatmapBackup, () => servicingSeatmapBackupInitialState),
];

/**
 * ServicingSeatmapBackup Store reducer
 */
export const servicingSeatmapBackupReducer = createReducer(
  servicingSeatmapBackupInitialState,
  ...servicingSeatmapBackupReducerFeatures
);